import { render, staticRenderFns } from "./SavedApplicationsDisplay.vue?vue&type=template&id=45995226&"
import script from "./SavedApplicationsDisplay.vue?vue&type=script&lang=js&"
export * from "./SavedApplicationsDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports